import { useFeature } from "@/hooks/useFeature";
import type { ReactNode } from "react";

type FeatureGuardProps = {
  feature: string;
  children: ReactNode;
  fallback?: ReactNode;
};

export const FeatureGuard = ({
  feature,
  children,
  fallback = null
}: FeatureGuardProps) => {
  const hasAccess = useFeature(feature);

  if (!hasAccess) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
